import { render, staticRenderFns } from "./BuildingViewImage.vue?vue&type=template&id=2f580bb7&scoped=true&"
import script from "./BuildingViewImage.vue?vue&type=script&lang=js&"
export * from "./BuildingViewImage.vue?vue&type=script&lang=js&"
import style0 from "./BuildingViewImage.vue?vue&type=style&index=0&id=2f580bb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f580bb7",
  null
  
)

export default component.exports